import type { NewsBanner } from '@/types/radio'

export function activeNewsBanners(banners: NewsBanner[]) {
  return (banners || []).filter((item) => item?.active && item?.mediaUrl)
}

export function pickWeightedNewsBanner(items: NewsBanner[], avoidId?: string) {
  if (!items.length) return null
  const pool = items.length > 1 && avoidId
    ? items.filter((item) => (item._id || item.title) !== avoidId)
    : items
  const total = pool.reduce((sum, item) => sum + Math.max(1, Number(item.weight || 1)), 0)
  let ticket = Math.random() * total
  for (const item of pool) {
    ticket -= Math.max(1, Number(item.weight || 1))
    if (ticket <= 0) return item
  }
  return pool[0] || items[0]
}

export type NewsFeedItem =
  | { kind: 'article'; key: string }
  | { kind: 'banner'; banner: NewsBanner; key: string }

export function interleaveNewsBanners(articleKeys: string[], banners: NewsBanner[], afterEvery = 1): NewsFeedItem[] {
  const ads = activeNewsBanners(banners)
  const interval = Math.max(1, afterEvery)
  const feed: NewsFeedItem[] = []
  let lastBannerId = ''
  articleKeys.forEach((key, index) => {
    feed.push({ kind: 'article', key })
    const isLast = index === articleKeys.length - 1
    const shouldInsert = Boolean(ads.length) && !isLast && (index + 1) % interval === 0
    if (!shouldInsert) return
    const banner = pickWeightedNewsBanner(ads, lastBannerId)
    if (!banner) return
    lastBannerId = banner._id || banner.title
    feed.push({ kind: 'banner', banner, key: `ad-${key}-${lastBannerId}-${index}` })
  })
  return feed
}
